/**
 * Pak Cloth House - Wishlist Manager
 * Modular, performant wishlist handler utilizing localStorage and event delegation.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'pchWishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      console.warn('Error reading wishlist from localStorage:', e);
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('pchWishlistUpdated', { detail: { items } }));
    } catch (e) {
      console.warn('Error saving wishlist to localStorage:', e);
    }
  }

  function updateWishlistButtons() {
    const wishlist = getWishlist();
    const wishlistedIds = new Set(wishlist.map(item => String(item.id)));

    document.querySelectorAll('.pch-product-wishlist').forEach(button => {
      const id = String(button.dataset.productId);
      const isWishlisted = wishlistedIds.has(id);
      button.classList.toggle('is-wishlisted', isWishlisted);
      button.setAttribute('aria-pressed', isWishlisted ? 'true' : 'false');
    });

    // Update header wishlist counters
    const count = wishlist.length;
    document.querySelectorAll('.header__wishlist-count').forEach(el => {
      el.textContent = count;
    });
    document.querySelectorAll('.header__wishlist-count-bubble').forEach(el => {
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // Delegated click handler: handles all existing and dynamically added product cards
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.pch-product-wishlist');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const productId = String(button.dataset.productId);
    if (!productId) return;

    let wishlist = getWishlist();
    const existingIndex = wishlist.findIndex(item => String(item.id) === productId);

    if (existingIndex !== -1) {
      wishlist.splice(existingIndex, 1);
      button.classList.remove('is-wishlisted');
      button.setAttribute('aria-pressed', 'false');
    } else {
      wishlist.push({
        id: productId,
        title: button.dataset.productTitle || '',
        url: button.dataset.productUrl || '',
        image: button.dataset.productImage || '',
        price: button.dataset.productPrice || ''
      });
      button.classList.add('is-wishlisted');
      button.setAttribute('aria-pressed', 'true');
    }

    saveWishlist(wishlist);
  }, true);

  // Sync state on load and when sections dynamically reload (Shopify Theme Editor & AJAX pagination)
  document.addEventListener('DOMContentLoaded', updateWishlistButtons);
  document.addEventListener('shopify:section:load', updateWishlistButtons);
  window.addEventListener('pchWishlistUpdated', updateWishlistButtons);

  // Expose global API for other theme widgets (e.g. wishlist page/drawer)
  window.PCHWishlist = {
    get: getWishlist,
    updateButtons: updateWishlistButtons
  };
})();
